module.exports = __webpack_public_path__ + "img/ff0505f.jpg";